import { createSlice } from '@reduxjs/toolkit';
import { storage } from '../../socket';

const savedName = storage.getItem('gamePortal_name') || '';
const savedSessionId = storage.getItem('gamePortal_sessionId') || null;

const userSlice = createSlice({
  name: 'user',
  initialState: {
    name: savedName,
    id: savedName ? savedSessionId : null,
    registered: !!savedName,
  },
  reducers: {
    setName(state, action) {
      state.name = action.payload;
    },
    setRegistered(state, action) {
      state.id = action.payload.id;
      state.registered = true;
    },
    logout(state) {
      state.name = '';
      state.id = null;
      state.registered = false;
    },
  },
});

export const { setName, setRegistered, logout } = userSlice.actions;
export default userSlice.reducer;
